<template>
  <div class="tw-grid tw-gap-1">
    <div class="tw-px-4 tw-py-2">
      <img src="@/assets/images/2025/sprout-logo-horizontal.svg" alt="sprout-logo-horizontal" />
    </div>

    <div
      :class="[
        'spr-w-full tw-m-auto tw-flex tw-min-h-[calc(100vh-60px)] tw-flex-col tw-justify-center tw-px-6',
        'md:tw-grid md:tw-min-h-max md:tw-py-6',
      ]"
    >
      <div
        :class="[
          'spr-max-w-md tw-m-auto tw-flex tw-w-full tw-items-center tw-justify-center tw-gap-10',
          'md:tw-grid md:tw-gap-6',
        ]"
      >
        <div :class="['tw-flex tw-justify-end', 'md:tw-justify-center']">
          <img class="md:tw-w-[60%]" src="@/assets/images/2025/access-denied.svg" alt="Access Denied" />
        </div>

        <div :class="['tw-grid tw-gap-6', 'md:tw-text-center']">
          <div class="tw-grid tw-gap-2">
            <h1 class="spr-heading-sm spr-text-color-strong tw-m-0">Access Denied</h1>
            <p class="spr-body-md-regular spr-text-color-base tw-m-0">
              Looks like you don’t have permissions to view this page. If you need access, contact your admin for
              assistance.
            </p>
            <spr-button
              class="md:!tw-w-full"
              tone="success"
              @click="goToDashboard"
              v-if="isEnableOlympusFeatureFlagOn && goToDashboardUrl"
              size="large"
            >
              Go to Dashboard
            </spr-button>
          </div>
          <div class="tw-grid tw-gap-2">
            <p class="spr-body-sm-regular spr-text-color-supporting tw-m-0">Need more help?</p>
            <a
              :class="['tw-w-fit', 'md:tw-m-auto']"
              href="https://guide.sprout.ph/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <spr-button class="tw-flex tw-items-center !tw-justify-between tw-gap-4" variant="secondary">
                <div class="tw-flex tw-items-center tw-gap-2">
                  <IconQuestionFill />
                  <span>Browse help center</span>
                </div>
                <IconArrowUpRight />
              </spr-button>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';

import { GetFeatureFlagList } from '@/services/FeatureFlags/GetFeatureFlagList';
import { GetEcosystemUrl } from '@/services/Ecosystem/GetEcosystemUrl';

import { FeatureFlagIdEnum } from '@/enums/featureFlagIds';

import IconQuestionFill from '~icons/ph/question-fill';
import IconArrowUpRight from '~icons/ph/arrow-up-right';

const isEnableOlympusFeatureFlagOn = ref(false);

const goToDashboardUrl = ref('');

const setEnableOlympusFeatureFlagOn = async () => {
  try {
    let featureFlags = await GetFeatureFlagList();

    let isOlypusEnabled = featureFlags.find((flag) => flag.keyId === FeatureFlagIdEnum.enableOlympus);

    if (!isOlypusEnabled && !isOlypusEnabled.keyValue) return;

    isEnableOlympusFeatureFlagOn.value = isOlypusEnabled.keyValue;

    try {
      goToDashboardUrl.value = await GetEcosystemUrl();
    } catch (urlError) {
      console.error('Error fetching ecosystem URL:', urlError);
    }
  } catch (flagError) {
    console.error('Error fetching feature flags:', flagError);
  }
};

const goToDashboard = () => {
  if (goToDashboardUrl.value) {
    window.location.href = goToDashboardUrl.value;
  }
};

onMounted(() => {
  setEnableOlympusFeatureFlagOn();

  const appEl = document.querySelector('#app');

  appEl.classList.remove('olympus-app');
});
</script>
